import { z } from 'zod/v3';
import { makeFieldSchemaFromZod } from '../utils';

export const TermsCheckboxUiOptionsSchema = z.object({
  labelText: z
    .string()
    .optional()
    .describe('Optional plain label text rendered without a hyperlink'),
  prefixText: z.string().optional().describe('The text before the link'),
  linkText: z
    .string()
    .optional()
    .describe('The text to be displayed for the hyperlink'),
  linkUrl: z
    .string()
    .url()
    .optional()
    .describe('The URL the hyperlink should point to'),
  suffixText: z
    .string()
    .optional()
    .describe('Optional non-clickable text rendered after the link'),
});

export type TermsCheckboxUiOptions = z.infer<
  typeof TermsCheckboxUiOptionsSchema
>;

export const TermsCheckboxSchema = makeFieldSchemaFromZod(
  z.boolean().describe('A checkbox with a label containing a hyperlink'),
  TermsCheckboxUiOptionsSchema,
);

export type TermsCheckboxProps = typeof TermsCheckboxSchema.type;
